module.exports = __webpack_public_path__ + "media/images/teams/logo__13-1a6770cfa07c03440372eb20e0b8d04a.svg";